import { useEffect, useRef, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';

// Importación de PDFs
import diplomado from "../assets/pdf/certificaciones/Diplomado.pdf";
import bachillerato from "../assets/pdf/certificaciones/Bachiller.pdf";
import scrum from "../assets/pdf/certificaciones/Scrum.pdf";
import spring from "../assets/pdf/certificaciones/Spring_Boot.pdf";

const useCertificates = () => {
    const { theme } = useTheme();
    const { language } = useLanguage();
    const certificatesRef = useRef(null);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const t = translations[language].certificates;

    // Mapeo de PDFs para los certificados
    const certificatePdfs = {
        "Bachillerato en Ingeniería en Sistemas de Información": bachillerato,
        "Bachelor’s Degree in Information Systems Engineering": bachillerato,
        "Certificado Fundamentos de Scrum": scrum,
        "Scrum Fundamentals Certified": scrum,
        "Spring Framework y Spring Boot": spring,
        "Spring Framework and Spring Boot": spring,
        "Diplomado De Programación De Aplicaciones Informáticas": diplomado,
        "Diploma in Computer Application Programming": diplomado
    };

    const categories = [
        { id: 'all', icon: 'certificate' },
        { id: 'academic', icon: 'graduation-cap' },
        { id: 'technical', icon: 'calendar-alt' },
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('fade-in');
                    }
                });
            },
            { threshold: 0.1 }
        );

        const certItems = document.querySelectorAll('.certificate-card');
        certItems.forEach(item => observer.observe(item));

        return () => {
            certItems.forEach(item => observer.unobserve(item));
        };
    }, [selectedCategory]);

    const openPdf = (title) => {
        window.open(certificatePdfs[title], '_blank');
    };

    const filteredCertificates = selectedCategory === 'all' 
        ? t.list 
        : t.list.filter(cert => cert.category === selectedCategory);

    return {
        theme,
        t,
        categories,
        certificatesRef,
        selectedCategory, 
        setSelectedCategory,
        filteredCertificates,
        openPdf,
        certificatePdfs
    };
};

export default useCertificates;